import { Box, makeStyles } from "@material-ui/core"
import { SectionHeader } from "@ksana/vira-ui"
import React, { FC, useState } from "react"
import ChevronDownIcon from "../atoms/ChevronDownIcon"
import ChevronUpIcon from "../atoms/ChevronUpIcon"

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
  },
  averages: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    minWidth: 0,
  },
  chevronButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: 4,
    margin: 0,
  },
}))

interface Props {
  title: string
  DailyAverages?: FC
  Chart: FC
  /** Kept for call-site compat; charts themselves use ContentCard. */
  variant?: "default" | "clientDetail"
}

/**
 * Section chrome for a chart group. Individual charts render ContentCard;
 * this only provides the section title + optional weekly averages + collapse.
 */
const ChartAccordion: FC<Props> = ({ title, DailyAverages, Chart }) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(true)
  const toggle = () => setExpanded((prev) => !prev)

  return (
    <div className={classes.root}>
      <SectionHeader
        level="section"
        title={title}
        actions={
          <button
            type="button"
            className={classes.chevronButton}
            aria-expanded={expanded}
            aria-label={expanded ? "Collapse" : "Expand"}
            onClick={toggle}
          >
            {expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </button>
        }
      />
      {DailyAverages && expanded ? (
        <div className={classes.averages}>
          <DailyAverages />
        </div>
      ) : null}
      {expanded ? (
        <Box width="100%" maxWidth="100%" minWidth={0}>
          <Chart />
        </Box>
      ) : null}
    </div>
  )
}

export default ChartAccordion
